define('view/disclosure/persistent.left.sidebar.modals',['require','exports','module','backbone','blockit','uikit/uikit','backbone.radio','view/disclosure/modals/confirm.review.completion.modal','view/disclosure/modals/decision.confirmation.modal','view/disclosure/modals/reviewer.assignment.modal','view/disclosure/modals/disclosure.return.to.disclosee.modal','view/disclosure/modals/remove.reviewer.confirmation.modal'],function(require, exports, module) {
  //prettier-ignore
  var Backbone                        = require('backbone'),
      BlocKit                         = require('blockit'),
      UIKit                           = require('uikit/uikit'),
      Radio                           = require('backbone.radio'),
      ConfirmReviewCompletionModal    = require('view/disclosure/modals/confirm.review.completion.modal'),
      DecisionConfirmationModal       = require('view/disclosure/modals/decision.confirmation.modal'),
      ReviewerAssignmentModal         = require('view/disclosure/modals/reviewer.assignment.modal'),
      ConfirmReturnToDiscloseeModal    = require('view/disclosure/modals/disclosure.return.to.disclosee.modal'),
      RemoveReviewerConfirmationModal = require('view/disclosure/modals/remove.reviewer.confirmation.modal');

  var PersistentLeftSidebarModals = {
    //Modals
    reviewerAssignmentModal: {
      type: ReviewerAssignmentModal,
      availableReviewersCollection: '@resources.availableReviewersCollection',
      model: '@resources.disclosureAssignmentDetailModel',
    },
    removeReviewerConfirmationModal: {
      type: RemoveReviewerConfirmationModal,
      model: '@resources.disclosure',
      disclosureAssignmentDetailModel: '@resources.disclosureAssignmentDetailModel',
    },
    confirmReviewCompletionModal: {
      type: ConfirmReviewCompletionModal,
    },

    confirmReturnToDiscloseeModal: {
      type: ConfirmReturnToDiscloseeModal,
    },

    decisionConfirmationModal: {
      type: DecisionConfirmationModal,
      behaviors: {
        FetchResourcesOnFirstRenderEventBehavior: {
          resources: ['@resources.sessionDecisionModel'],
          eventName: 'first:render',
          fetchModelIfNew: true,
          behaviorClass: BlocKit.FetchResourcesOnEventBehavior,
        },
      },
      resourceErrorsOptions: {
        includeOnlyControllerResources: ['@resources.sessionDecisionModel'],
      },
      // fetchModelOnDeny: true,
      outcomeCollection: '@resources.outcomeCollection',
      decisionModel: '@resources.sessionDecisionModel',
      // personModel: '@resources.userPrincipalModel',
      model: '@resources.sessionDecisionModel',
    },
  };

  module.exports = PersistentLeftSidebarModals;
});

